function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import clamp from 'lodash.clamp';
import GridMouseHandler from "../GridMouseHandler.js";
/* eslint class-methods-use-this: "off" */
class GridHorizontalScrollBarMouseHandler extends GridMouseHandler {
  constructor() {
    super(...arguments);
    _defineProperty(this, "dragOffset", void 0);
    // to trigger pointer event blocking
    _defineProperty(this, "cursor", 'default');
  }
  static getLeftWithOffsetFromRawLeft(grid, rawLeft) {
    var theme = grid.getTheme();
    var metrics = grid.metrics,
      metricCalculator = grid.metricCalculator;
    if (!metrics) throw new Error('metrics not set');
    if (theme.scrollSnapToColumn) {
      var _left = Math.round(rawLeft);
      var _leftOffset = 0;
      return {
        left: _left,
        leftOffset: _leftOffset
      };
    }
    var left = Math.floor(rawLeft);
    var leftOffsetPercent = rawLeft - left;
    var columnWidth = metrics.allColumnWidths.get(left);
    if (columnWidth == null) {
      var metricState = grid.getMetricState();
      columnWidth = metricCalculator.getVisibleColumnWidth(left, metricState);
    }
    var leftOffset = columnWidth * leftOffsetPercent;
    return {
      left,
      leftOffset
    };
  }
  isInScrollBar(gridPoint, grid) {
    var theme = grid.getTheme();
    var scrollBarSize = theme.scrollBarSize,
      scrollBarHoverSize = theme.scrollBarHoverSize;
    var metrics = grid.metrics;
    if (!metrics) throw new Error('metrics not set');
    var x = gridPoint.x,
      y = gridPoint.y;
    var barLeft = metrics.barLeft,
      barWidth = metrics.barWidth,
      height = metrics.height,
      hasHorizontalBar = metrics.hasHorizontalBar;
    return hasHorizontalBar && scrollBarSize > 0 && y >= height - scrollBarHoverSize && y < height && x > barLeft && x < barLeft + barWidth;
  }
  getLeftWithOffset(gridPoint, grid) {
    var _this$dragOffset;
    var metrics = grid.metrics;
    if (!metrics) throw new Error('metrics not set');
    var x = gridPoint.x;
    var barWidth = metrics.barWidth,
      handleWidth = metrics.handleWidth,
      lastLeft = metrics.lastLeft,
      barLeft = metrics.barLeft,
      columnCount = metrics.columnCount,
      scrollableContentWidth = metrics.scrollableContentWidth,
      scrollableViewportWidth = metrics.scrollableViewportWidth;
    var mouseBarX = x - barLeft;
    var scrollPercent = clamp((mouseBarX - ((_this$dragOffset = this.dragOffset) !== null && _this$dragOffset !== void 0 ? _this$dragOffset : 0)) / (barWidth - handleWidth), 0, 1);
    if (columnCount === 1) {
      return {
        left: 0,
        leftOffset: scrollPercent * (scrollableContentWidth - scrollableViewportWidth)
      };
    }
    var rawLeft = scrollPercent * lastLeft;
    return GridHorizontalScrollBarMouseHandler.getLeftWithOffsetFromRawLeft(grid, rawLeft);
  }
  onDown(gridPoint, grid) {
    var metrics = grid.metrics;
    if (!metrics) throw new Error('metrics not set');
    var x = gridPoint.x;
    var handleWidth = metrics.handleWidth,
      barLeft = metrics.barLeft,
      scrollX = metrics.scrollX;
    if (!this.isInScrollBar(gridPoint, grid)) {
      return false;
    }
    var mouseBarX = x - barLeft;
    if (mouseBarX >= scrollX && mouseBarX <= scrollX + handleWidth) {
      // Grabbed the horizontal handle
      this.dragOffset = mouseBarX - scrollX;
      grid.setState({
        isDraggingHorizontalScrollBar: true
      });
    } else {
      this.dragOffset = 0;
      var _this$getLeftWithOffs = this.getLeftWithOffset(gridPoint, grid),
        newLeft = _this$getLeftWithOffs.left,
        newLeftOffset = _this$getLeftWithOffs.leftOffset;
      grid.setViewState({
        left: newLeft,
        leftOffset: newLeftOffset,
        isDraggingHorizontalScrollBar: true,
        isDragging: true
      });
    }
    return true;
  }
  onDrag(gridPoint, grid) {
    if (this.dragOffset != null) {
      var _this$getLeftWithOffs2 = this.getLeftWithOffset(gridPoint, grid),
        newLeft = _this$getLeftWithOffs2.left,
        newLeftOffset = _this$getLeftWithOffs2.leftOffset;
      grid.setViewState({
        left: newLeft,
        leftOffset: newLeftOffset,
        isDraggingHorizontalScrollBar: true,
        isDragging: true
      });
      return true;
    }
    return false;
  }
  onMove(gridPoint, grid) {
    return this.isInScrollBar(gridPoint, grid);
  }
  onUp(gridPoint, grid) {
    if (this.dragOffset !== undefined) {
      this.dragOffset = undefined;
      grid.setState({
        isDraggingHorizontalScrollBar: false,
        isDragging: false
      });
    }
    return this.isInScrollBar(gridPoint, grid);
  }
  onClick(gridPoint, grid) {
    return this.isInScrollBar(gridPoint, grid);
  }
}
export default GridHorizontalScrollBarMouseHandler;
//# sourceMappingURL=GridHorizontalScrollBarMouseHandler.js.map